// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wellness-first {
  background-color: #e4e6eb;
}
.wellness-first .footer-container {
  margin: 15px 0px 20px 0px !important;
}
.wellness-first .homePage-navbar {
  height: max-content;
}

.wellness-page {
  background-color: rgb(247, 248, 249) !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.wellness-page .quickAccess-results {
  height: 100vh !important;
  padding-left: 0px;
  position: sticky;
  top: 0;
}
.wellness-page .container-quick-access {
  align-self: flex-start;
  position: sticky !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0);
  padding: 0px 1rem 0rem 0rem !important;
  top: 0;
}
.wellness-page .container-quick-access-detail {
  position: sticky !important;
  padding: 0px !important;
  height: 100vh !important;
  margin-top: 0px !important;
}
.wellness-page .footer-container {
  margin: 15px 0px 20px 0px !important;
  width: 100% !important;
}
.wellness-page .container-quickAccess-logged {
  padding-left: 0px !important;
  margin-top: -305px;
  position: sticky;
  top: 0px !important;
  height: 100vh !important;
}
.wellness-page .container-quickAccess-logged-detail {
  padding: 0px !important;
  position: sticky !important;
  top: 0px !important;
  margin-top: -100px;
}
.wellness-page .logged-navbar {
  padding: 0px !important;
}
.wellness-page .logged-navbar .dropdowns-containers-navbar {
  margin: 0px !important;
  padding: 0px !important;
  width: 100% !important;
}
.wellness-page .headers-home {
  width: 100%;
  z-index: 10;
  padding: 0px !important;
  margin: 0px !important;
}
.wellness-page p {
  font-family: "Lato", sans-serif !important;
  text-align: left;
  align-self: flex-start;
}
.wellness-page h4 {
  font-family: "Lato", sans-serif !important;
  text-align: left;
  align-self: flex-start;
}
.wellness-page .title-event {
  color: rgb(119, 119, 118);
  padding-top: 10px;
  font-weight: auto;
}
.wellness-page .title-event-time {
  color: rgb(48, 97, 188);
  padding-top: 10px;
  text-align: left;
  align-self: flex-start;
}
.wellness-page .container-menu {
  padding-left: 1.5rem;
  margin-bottom: -1rem;
}
.wellness-page .title-page h3 {
  padding-left: 1rem;
  font-family: "Lato", sans-serif !important;
}
.wellness-page .quickAcces-container {
  z-index: 10 !important;
  box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.16) !important;
  margin: 0 !important;
}
.wellness-page .quickAcces-container .quickAccess-title-container {
  position: relative !important;
  left: 10px !important;
  top: 0px !important;
}
.wellness-page .quickAcces-container .quickAccess-ul {
  width: 100% !important;
}
.wellness-page .item-time {
  padding-top: 15px;
  text-align: left;
  align-self: flex-start;
}
.wellness-page .line-time {
  border-bottom: 1px solid rgb(234, 234, 234);
}
.wellness-page .time-text {
  padding-top: 0px !important;
  margin: 0px !important;
}
.wellness-page .row-main-container {
  background-color: #e4e6eb !important;
  width: 100%;
  margin: 0px;
}

.item-wellness-event {
  background-color: rgb(255, 255, 255);
  margin: 5px;
  padding: 12px;
  display: flex;
  flex: 1 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
}

.item-wellness-event-border {
  background-color: rgb(255, 255, 255);
  height: 83px;
  margin: 5px;
  border-radius: 12px;
  padding: 0px;
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  border-bottom: 1px solid rgb(204, 204, 204);
  width: 100%;
}

.month {
  width: 30px;
  text-align: center;
  letter-spacing: 0px;
  color: black;
  font-size: 12px;
  font-family: "Lato", sans-serif !important;
  padding: 0px !important;
  margin: 0px !important;
}

.day {
  width: 30px;
  text-align: center;
  letter-spacing: 0px;
  font-size: 20px;
  font-family: "Lato", sans-serif !important;
  font-weight: 700;
  padding: 0px !important;
  margin: 0px !important;
}

.date-item-wellness {
  width: 30px;
  height: 30px;
  text-align: center !important;
  align-self: center !important;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.row-container-date {
  background-color: rgba(0, 0, 0, 0);
  display: flex !important;
  flex: 1 1;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  align-self: flex-start;
}

.item-wellness-date-container {
  width: 56px !important;
  height: 83px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #9bc356 !important;
  font-family: "Lato", sans-serif !important;
  font-size: 16px;
  color: #1a1919;
  border-radius: 12px;
}

.label-text-wellness {
  text-align: right;
}

.label-description-wellness {
  text-align: flex-start;
  align-self: flex-start;
  background-color: rgb(255, 255, 255);
  padding: 0px !important;
  margin: 0px !important;
}

.wellness-events-container {
  width: 100% !important;
  display: block !important;
}
.wellness-events-container .spinner-container {
  width: 100%;
  height: 20em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wellness-events-container .strings-container {
  margin-left: 1% !important;
}

.event-title {
  font-size: 16px;
  color: #4e7da2;
  align-self: flex-start;
  text-align: left;
  padding: 0px !important;
  font-family: "Lato", sans-serif !important;
}

.text-muted {
  font-size: 13px;
  color: #4e7da2;
  text-align: left;
  padding: 0px 10px 0px 0px !important;
  margin: 0px !important;
}

.col-title-class {
  padding: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 1rem !important;
  margin-bottom: 0px !important;
}

.col-description-class {
  padding-left: 65px !important;
  margin-top: -5px;
  padding: 0px;
}

.detail-data-time {
  padding: 25px;
  border-radius: 12px !important;
}

.detail-data-description {
  padding: 25px;
  border-radius: 12px !important;
  align-self: flex-start;
  justify-content: flex-start;
}

.container-data-wellness {
  background-color: #e4e6eb !important;
  justify-content: center !important;
  align-self: flex-start;
  height: 100%;
}

.spinner {
  align-self: center;
  padding-left: 15px !important;
}

.pagination-classes {
  background-color: rgba(0, 0, 0, 0) !important;
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding-right: 40px;
  padding-top: 20px;
}

.detail-container {
  background-color: rgb(255, 255, 255) !important;
  padding: 25px;
  margin: 43px 4rem 8rem 1.5rem !important;
  border-radius: 25px;
  width: 94% !important;
}

.detail-container-box {
  background-color: rgb(255, 255, 255) !important;
  padding: 25px;
  padding-top: 0px !important;
}

.no-data-available {
  padding: 25px;
  text-align: center !important;
  align-self: center !important;
  border: 1px solid black;
  color: rgb(119, 119, 118);
  width: 100%;
}

.button-register {
  background-color: #63b28b !important;
  color: rgb(255, 255, 255) !important;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding: 15px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
  height: max-content;
}
.button-register a {
  color: rgb(255, 255, 255) !important;
  align-self: center !important;
  text-align: center !important;
  text-transform: uppercase !important;
}

.container-quickAccess-wellness {
  align-self: flex-start;
  position: sticky !important;
  top: 132px;
  background-color: rgba(0, 0, 0, 0);
}

.container-spinner {
  background-color: rgb(255, 255, 255);
  height: 55vh;
  align-items: center !important;
  align-content: center !important;
  justify-content: center !important;
  display: flex;
}

@media (max-width: 1200px) {
  .container-data-wellness {
    padding: 20px !important;
    margin: 0px !important;
  }
  .container-quickAccess-logged {
    display: none !important;
  }
  .container-quick-access-detail {
    display: none !important;
  }
  .wellness-page {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 64px !important;
    width: calc(100vw - 65px) !important;
  }
  .wellness-page .wellness-page .footer-container {
    margin: 15px 0px 0px 0px !important;
  }
  .quickAccess-results {
    display: none;
  }
  .detail-container {
    margin-top: 3rem !important;
  }
  .column-footer {
    margin: 30px 0px 0px 0px !important;
  }
}
@media screen and (max-width: 768px) {
  .container-data-wellness {
    justify-content: center !important;
    align-self: center !important;
    align-items: center !important;
    align-content: center !important;
    height: 100%;
    width: 100% !important;
  }
}
@media (max-width: 576px) {
  .wellness-page {
    background-color: #f7f8f9;
    padding: 0 !important;
    margin: 0px 0px !important;
    width: 100% !important;
  }
  .detail-container {
    margin: 43px 0rem 3rem 0.5rem !important;
  }
}
.title-event {
  font-weight: 700;
  margin-bottom: 0.5em;
}

.detail-class-title {
  display: flex;
  gap: 1em;
  align-items: center;
}

.detail-title {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/welleneseventscontainer/wellnesseventscontainer.scss","webpack://./src/sass/layout/welleneseventscontainer/wellnesseventscontainer.css","webpack://./src/sass/utilities/_mixins.scss","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAIA;EACE,yBAAA;ACHF;ADIE;EACE,oCAAA;ACFJ;ADIE;EACE,mBAAA;ACFJ;;ADKA;EEJE,+CAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;ADGF;ADDE;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;ACGJ;ADDE;EACE,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,kCGlBU;EHmBV,sCAAA;EACA,MAAA;ACGJ;ADDE;EACE,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;ACGJ;ADDE;EACE,oCAAA;EACA,sBAAA;ACGJ;ADDE;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;ACGJ;ADDE;EACE,uBAAA;EAEA,2BAAA;EACA,mBAAA;EACA,kBAAA;ACEJ;ADAE;EACE,uBAAA;ACEJ;ADDI;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;ACGN;ADCE;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;ACCJ;ADEE;EACE,0CGpEG;EHqEH,gBAAA;EACA,sBAAA;ACAJ;ADGE;EACE,0CG1EG;EH2EH,gBAAA;EACA,sBAAA;ACDJ;ADIE;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;ACFJ;ADKE;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;ACHJ;ADKE;EACE,oBAAA;EACA,oBAAA;ACHJ;ADMI;EACE,kBAAA;EACA,0CGlGC;AF8FP;ADOE;EACE,sBAAA;EACA,uDAAA;EAUA,oBAAA;ACdJ;ADMI;EACE,6BAAA;EACA,qBAAA;EACA,mBAAA;ACJN;ADMI;EACE,sBAAA;ACJN;ADQE;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;ACNJ;ADSE;EACE,2CAAA;ACPJ;ADUE;EACE,2BAAA;EACA,sBAAA;ACRJ;ADWE;EACE,oCAAA;EACA,WAAA;EACA,WAAA;ACTJ;;ADaA;EACE,oCGnIM;EHoIN,WAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;ACVF;;ADaA;EACE,oCGhJM;EHiJN,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,2CAAA;EACA,WAAA;ACVF;;ADaA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,0CG3KK;EH4KL,uBAAA;EACA,sBAAA;ACVF;;ADYA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CGpLK;EHqLL,gBAAA;EACA,uBAAA;EACA,sBAAA;ACTF;;ADYA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACTF;;ADYA;EACE,kCGhMY;EHiMZ,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ACTF;;ADYA;EACE,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0CGtNK;EHuNL,eAAA;EACA,cAAA;EACA,mBAAA;ACTF;;ADYA;EACE,iBAAA;ACTF;;ADYA;EACE,sBAAA;EACA,sBAAA;EACA,oCG5NM;EH6NN,uBAAA;EACA,sBAAA;ACTF;;ADYA;EACE,sBAAA;EACA,yBAAA;ACTF;ADWE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACTJ;ADYE;EACE,0BAAA;ACVJ;;ADcA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0CG/PK;AFoPP;;ADcA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;ACXF;;ADcA;EACE,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;ACXF;;ADcA;EACE,6BAAA;EACA,gBAAA;EACA,YAAA;ACXF;;ADcA;EACE,aAAA;EACA,8BAAA;ACXF;;ADcA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,2BAAA;ACXF;;ADcA;EACE,oCAAA;EACA,kCAAA;EACA,sBAAA;EACA,YAAA;ACXF;;ADcA;EACE,kBAAA;EACA,6BAAA;ACXF;;ADcA;EACE,6CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;ACXF;;ADcA;EACE,+CAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,qBAAA;ACXF;;ADcA;EACE,+CAAA;EACA,aAAA;EACA,2BAAA;ACXF;;ADcA;EACE,aAAA;EACA,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;ACXF;;ADcA;EACE,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,0CGxVK;EHyVL,mBAAA;ACXF;ADaE;EACE,oCAAA;EACA,6BAAA;EACA,6BAAA;EACA,oCAAA;ACXJ;;ADeA;EACE,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,kCGlWY;AFsVd;;ADeA;EACE,oCGpWM;EHqWN,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,kCAAA;EACA,aAAA;ACZF;;ADeA;EACE;IACE,wBAAA;IACA,sBAAA;ECZF;EDcA;IACE,wBAAA;ECZF;EDcA;IACE,wBAAA;ECZF;EDcA;IACE,yBAAA;IACA,qBAAA;IACA,2BAAA;IACA,oCAAA;ECZF;EDcI;IACE,mCAAA;ECZN;EDgBA;IACE,aAAA;ECdF;EDgBA;IACE,2BAAA;ECdF;EDgBA;IACE,mCAAA;ECdF;AACF;ADiBA;EACE;IACE,kCAAA;IACA,6BAAA;IACA,8BAAA;IACA,gCAAA;IACA,YAAA;IACA,sBAAA;ECfF;AACF;ADkBA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,0BAAA;IACA,sBAAA;EChBF;EDkBA;IACE,wCAAA;EChBF;AACF;ADmBA;EACE,gBAAA;EACA,oBAAA;ACjBF;;ADoBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ACjBF;;ADoBA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;ACjBF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n \n\n.wellness-first {\n  background-color: #e4e6eb;\n  .footer-container {\n    margin: 15px 0px 20px 0px !important;\n  }\n  .homePage-navbar {\n    height: max-content;\n  }\n}\n.wellness-page {\n  @include settingsPage();\n  .quickAccess-results {\n    height: 100vh !important;\n    padding-left: 0px;\n    position: sticky;\n    top: 0;\n  }\n  .container-quick-access {\n    align-self: flex-start;\n    position: sticky !important;\n    height: 100vh !important;\n    background-color: $Transparent;\n    padding: 0px 1rem 0rem 0rem !important;\n    top: 0;\n  }\n  .container-quick-access-detail {\n    position: sticky !important;\n    padding: 0px !important;\n    height: 100vh !important;\n    margin-top: 0px !important;\n  }\n  .footer-container {\n    margin: 15px 0px 20px 0px !important;\n    width: 100% !important;\n  }\n  .container-quickAccess-logged {\n    padding-left: 0px !important;\n    margin-top: -305px;\n    position: sticky;\n    top: 0px !important;\n    height: 100vh !important;\n  }\n  .container-quickAccess-logged-detail {\n    padding: 0px !important;\n    // height: 100vh !important;\n    position: sticky !important;\n    top: 0px !important;\n    margin-top: -100px;\n  }\n  .logged-navbar {\n    padding: 0px !important;\n    .dropdowns-containers-navbar {\n      margin: 0px !important;\n      padding: 0px !important;\n      width: 100% !important;\n    }\n  }\n\n  .headers-home {\n    width: 100%;\n    z-index: 10;\n    padding: 0px !important;\n    margin: 0px !important;\n  }\n\n  p {\n    font-family: $Font;\n    text-align: left;\n    align-self: flex-start;\n  }\n\n  h4 {\n    font-family: $Font;\n    text-align: left;\n    align-self: flex-start;\n  }\n\n  .title-event {\n    color: rgba(119, 119, 118, 1);\n    padding-top: 10px;\n    font-weight: auto;\n  }\n\n  .title-event-time {\n    color: rgba(48, 97, 188, 1);\n    padding-top: 10px;\n    text-align: left;\n    align-self: flex-start;\n  }\n  .container-menu {\n    padding-left: 1.5rem;\n    margin-bottom: -1rem;\n  }\n  .title-page {\n    h3 {\n      padding-left: 1rem;\n      font-family: $Font;\n    }\n  }\n  .quickAcces-container {\n    z-index: 10 !important;\n    box-shadow: 0px 3px 11px rgb(0 0 0 / 16%) !important;\n\n    .quickAccess-title-container {\n      position: relative !important;\n      left: 10px !important;\n      top: 0px !important;\n    }\n    .quickAccess-ul {\n      width: 100% !important;\n    }\n    margin: 0 !important;\n  }\n  .item-time {\n    padding-top: 15px;\n    text-align: left;\n    align-self: flex-start;\n  }\n\n  .line-time {\n    border-bottom: 1px solid rgba(234, 234, 234, 1);\n  }\n\n  .time-text {\n    padding-top: 0px !important;\n    margin: 0px !important;\n  }\n\n  .row-main-container {\n    background-color: #e4e6eb !important;\n    width: 100%;\n    margin: 0px;\n  }\n}\n\n.item-wellness-event {\n  background-color: $White;\n  margin: 5px;\n  padding: 12px;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n  width: 100%;\n}\n\n.item-wellness-event-border {\n  background-color: $White;\n  height: 83px;\n  margin: 5px;\n  border-radius: 12px;\n  padding: 0px;\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n  border-bottom: 1px solid $GrayColor;\n  width: 100%;\n}\n\n.month {\n  width: 30px;\n  text-align: center;\n  letter-spacing: 0px;\n  color: black;\n  font-size: 12px;\n  font-family: $Font;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n.day {\n  width: 30px;\n  text-align: center;\n  letter-spacing: 0px;\n  font-size: 20px;\n  font-family: $Font;\n  font-weight: 700;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.date-item-wellness {\n  width: 30px;\n  height: 30px;\n  text-align: center !important;\n  align-self: center !important;\n  letter-spacing: 0px;\n  color: #ffffff;\n  opacity: 1;\n}\n\n.row-container-date {\n  background-color: $Transparent;\n  display: flex !important;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: flex-start;\n  align-self: flex-start;\n}\n\n.item-wellness-date-container {\n  width: 56px !important;\n  height: 83px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #9bc356 !important;\n  font-family: $Font;\n  font-size: 16px;\n  color: #1a1919;\n  border-radius: 12px;\n}\n\n.label-text-wellness {\n  text-align: right;\n}\n\n.label-description-wellness {\n  text-align: flex-start;\n  align-self: flex-start;\n  background-color: $White;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.wellness-events-container {\n  width: 100% !important;\n  display: block !important;\n  \n  .spinner-container{\n    width: 100%;\n    height: 20em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .strings-container {\n    margin-left: 1% !important;\n  }\n}\n\n.event-title {\n  font-size: 16px;\n  color: #4e7da2;\n  align-self: flex-start;\n  text-align: left;\n  padding: 0px !important;\n  font-family: $Font;\n}\n\n.text-muted {\n  font-size: 13px;\n  color: #4e7da2;\n  text-align: left;\n  padding: 0px 10px 0px 0px!important;\n  margin: 0px !important;\n}\n\n.col-title-class {\n  padding: 0px !important;\n  padding-bottom: 0px !important;\n  padding-left: 1rem !important;\n  margin-bottom: 0px !important;\n}\n\n.col-description-class {\n  padding-left: 65px !important;\n  margin-top: -5px;\n  padding: 0px;\n}\n\n.detail-data-time {\n  padding: 25px;\n  border-radius: 12px !important;\n}\n\n.detail-data-description {\n  padding: 25px;\n  border-radius: 12px !important;\n  align-self: flex-start;\n  justify-content: flex-start;\n}\n\n.container-data-wellness {\n  background-color: #e4e6eb !important;\n  justify-content: center !important;\n  align-self: flex-start;\n  height: 100%;\n}\n\n.spinner {\n  align-self: center;\n  padding-left: 15px !important;\n}\n\n.pagination-classes {\n  background-color: $Transparent !important;\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  padding-right: 40px;\n  padding-top: 20px;\n}\n\n.detail-container {\n  background-color: $White !important;\n  padding: 25px;\n  margin: 43px 4rem 8rem 1.5rem !important;\n  border-radius: 25px;\n  width: 94% !important;\n}\n\n.detail-container-box {\n  background-color: $White !important;\n  padding: 25px;\n  padding-top: 0px !important;\n}\n\n.no-data-available {\n  padding: 25px;\n  text-align: center !important;\n  align-self: center !important;\n  border: 1px solid black;\n  color: rgba(119, 119, 118, 1);\n  width: 100%;\n}\n\n.button-register {\n  background-color: #63b28b !important;\n  color: $White !important;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n  height: max-content;\n\n  a {\n    color: $White !important;\n    align-self: center !important;\n    text-align: center !important;\n    text-transform: uppercase !important;\n  }\n}\n\n.container-quickAccess-wellness {\n  align-self: flex-start;\n  position: sticky !important;\n  top: 132px;\n  background-color: $Transparent;\n}\n\n.container-spinner {\n  background-color: $White;\n  height: 55vh;\n  align-items: center !important;\n  align-content: center !important;\n  justify-content: center !important;\n  display: flex;\n}\n\n@media (max-width: 1200px) {\n  .container-data-wellness {\n    padding: 20px !important;\n    margin: 0px !important;\n  }\n  .container-quickAccess-logged {\n    display: none !important;\n  }\n  .container-quick-access-detail {\n    display: none !important;\n  }\n  .wellness-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n    .wellness-page {\n      .footer-container {\n        margin: 15px 0px 0px 0px !important;\n      }\n    }\n  }\n  .quickAccess-results {\n    display: none;\n  }\n  .detail-container {\n    margin-top: 3rem !important;\n  }\n  .column-footer {\n    margin: 30px 0px 0px 0px !important;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .container-data-wellness {\n    justify-content: center !important;\n    align-self: center !important;\n    align-items: center !important;\n    align-content: center !important;\n    height: 100%;\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .wellness-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n  .detail-container {\n    margin: 43px 0rem 3rem 0.5rem !important;\n  }\n}\n\n.title-event {\n  font-weight: 700;\n  margin-bottom: .5em;\n}\n\n.detail-class-title {\n  display: flex;\n  gap: 1em;\n  align-items: center;\n}\n\n.detail-title{\n  font-size: 1.5em;\n  font-weight: 700;\n  margin-bottom: .5em;\n}",".wellness-first {\n  background-color: #e4e6eb;\n}\n.wellness-first .footer-container {\n  margin: 15px 0px 20px 0px !important;\n}\n.wellness-first .homePage-navbar {\n  height: -moz-max-content;\n  height: max-content;\n}\n\n.wellness-page {\n  background-color: rgb(247, 248, 249) !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n.wellness-page .quickAccess-results {\n  height: 100vh !important;\n  padding-left: 0px;\n  position: sticky;\n  top: 0;\n}\n.wellness-page .container-quick-access {\n  align-self: flex-start;\n  position: sticky !important;\n  height: 100vh !important;\n  background-color: rgba(0, 0, 0, 0);\n  padding: 0px 1rem 0rem 0rem !important;\n  top: 0;\n}\n.wellness-page .container-quick-access-detail {\n  position: sticky !important;\n  padding: 0px !important;\n  height: 100vh !important;\n  margin-top: 0px !important;\n}\n.wellness-page .footer-container {\n  margin: 15px 0px 20px 0px !important;\n  width: 100% !important;\n}\n.wellness-page .container-quickAccess-logged {\n  padding-left: 0px !important;\n  margin-top: -305px;\n  position: sticky;\n  top: 0px !important;\n  height: 100vh !important;\n}\n.wellness-page .container-quickAccess-logged-detail {\n  padding: 0px !important;\n  position: sticky !important;\n  top: 0px !important;\n  margin-top: -100px;\n}\n.wellness-page .logged-navbar {\n  padding: 0px !important;\n}\n.wellness-page .logged-navbar .dropdowns-containers-navbar {\n  margin: 0px !important;\n  padding: 0px !important;\n  width: 100% !important;\n}\n.wellness-page .headers-home {\n  width: 100%;\n  z-index: 10;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n.wellness-page p {\n  font-family: \"Lato\", sans-serif !important;\n  text-align: left;\n  align-self: flex-start;\n}\n.wellness-page h4 {\n  font-family: \"Lato\", sans-serif !important;\n  text-align: left;\n  align-self: flex-start;\n}\n.wellness-page .title-event {\n  color: rgb(119, 119, 118);\n  padding-top: 10px;\n  font-weight: auto;\n}\n.wellness-page .title-event-time {\n  color: rgb(48, 97, 188);\n  padding-top: 10px;\n  text-align: left;\n  align-self: flex-start;\n}\n.wellness-page .container-menu {\n  padding-left: 1.5rem;\n  margin-bottom: -1rem;\n}\n.wellness-page .title-page h3 {\n  padding-left: 1rem;\n  font-family: \"Lato\", sans-serif !important;\n}\n.wellness-page .quickAcces-container {\n  z-index: 10 !important;\n  box-shadow: 0px 3px 11px rgba(0, 0, 0, 0.16) !important;\n  margin: 0 !important;\n}\n.wellness-page .quickAcces-container .quickAccess-title-container {\n  position: relative !important;\n  left: 10px !important;\n  top: 0px !important;\n}\n.wellness-page .quickAcces-container .quickAccess-ul {\n  width: 100% !important;\n}\n.wellness-page .item-time {\n  padding-top: 15px;\n  text-align: left;\n  align-self: flex-start;\n}\n.wellness-page .line-time {\n  border-bottom: 1px solid rgb(234, 234, 234);\n}\n.wellness-page .time-text {\n  padding-top: 0px !important;\n  margin: 0px !important;\n}\n.wellness-page .row-main-container {\n  background-color: #e4e6eb !important;\n  width: 100%;\n  margin: 0px;\n}\n\n.item-wellness-event {\n  background-color: rgb(255, 255, 255);\n  margin: 5px;\n  padding: 12px;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n  width: 100%;\n}\n\n.item-wellness-event-border {\n  background-color: rgb(255, 255, 255);\n  height: 83px;\n  margin: 5px;\n  border-radius: 12px;\n  padding: 0px;\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n  border-bottom: 1px solid rgb(204, 204, 204);\n  width: 100%;\n}\n\n.month {\n  width: 30px;\n  text-align: center;\n  letter-spacing: 0px;\n  color: black;\n  font-size: 12px;\n  font-family: \"Lato\", sans-serif !important;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.day {\n  width: 30px;\n  text-align: center;\n  letter-spacing: 0px;\n  font-size: 20px;\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: 700;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.date-item-wellness {\n  width: 30px;\n  height: 30px;\n  text-align: center !important;\n  align-self: center !important;\n  letter-spacing: 0px;\n  color: #ffffff;\n  opacity: 1;\n}\n\n.row-container-date {\n  background-color: rgba(0, 0, 0, 0);\n  display: flex !important;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: flex-start;\n  align-self: flex-start;\n}\n\n.item-wellness-date-container {\n  width: 56px !important;\n  height: 83px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #9bc356 !important;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 16px;\n  color: #1a1919;\n  border-radius: 12px;\n}\n\n.label-text-wellness {\n  text-align: right;\n}\n\n.label-description-wellness {\n  text-align: flex-start;\n  align-self: flex-start;\n  background-color: rgb(255, 255, 255);\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.wellness-events-container {\n  width: 100% !important;\n  display: block !important;\n}\n.wellness-events-container .spinner-container {\n  width: 100%;\n  height: 20em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.wellness-events-container .strings-container {\n  margin-left: 1% !important;\n}\n\n.event-title {\n  font-size: 16px;\n  color: #4e7da2;\n  align-self: flex-start;\n  text-align: left;\n  padding: 0px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.text-muted {\n  font-size: 13px;\n  color: #4e7da2;\n  text-align: left;\n  padding: 0px 10px 0px 0px !important;\n  margin: 0px !important;\n}\n\n.col-title-class {\n  padding: 0px !important;\n  padding-bottom: 0px !important;\n  padding-left: 1rem !important;\n  margin-bottom: 0px !important;\n}\n\n.col-description-class {\n  padding-left: 65px !important;\n  margin-top: -5px;\n  padding: 0px;\n}\n\n.detail-data-time {\n  padding: 25px;\n  border-radius: 12px !important;\n}\n\n.detail-data-description {\n  padding: 25px;\n  border-radius: 12px !important;\n  align-self: flex-start;\n  justify-content: flex-start;\n}\n\n.container-data-wellness {\n  background-color: #e4e6eb !important;\n  justify-content: center !important;\n  align-self: flex-start;\n  height: 100%;\n}\n\n.spinner {\n  align-self: center;\n  padding-left: 15px !important;\n}\n\n.pagination-classes {\n  background-color: rgba(0, 0, 0, 0) !important;\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  padding-right: 40px;\n  padding-top: 20px;\n}\n\n.detail-container {\n  background-color: rgb(255, 255, 255) !important;\n  padding: 25px;\n  margin: 43px 4rem 8rem 1.5rem !important;\n  border-radius: 25px;\n  width: 94% !important;\n}\n\n.detail-container-box {\n  background-color: rgb(255, 255, 255) !important;\n  padding: 25px;\n  padding-top: 0px !important;\n}\n\n.no-data-available {\n  padding: 25px;\n  text-align: center !important;\n  align-self: center !important;\n  border: 1px solid black;\n  color: rgb(119, 119, 118);\n  width: 100%;\n}\n\n.button-register {\n  background-color: #63b28b !important;\n  color: rgb(255, 255, 255) !important;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n  height: -moz-max-content;\n  height: max-content;\n}\n.button-register a {\n  color: rgb(255, 255, 255) !important;\n  align-self: center !important;\n  text-align: center !important;\n  text-transform: uppercase !important;\n}\n\n.container-quickAccess-wellness {\n  align-self: flex-start;\n  position: sticky !important;\n  top: 132px;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.container-spinner {\n  background-color: rgb(255, 255, 255);\n  height: 55vh;\n  align-items: center !important;\n  align-content: center !important;\n  justify-content: center !important;\n  display: flex;\n}\n\n@media (max-width: 1200px) {\n  .container-data-wellness {\n    padding: 20px !important;\n    margin: 0px !important;\n  }\n  .container-quickAccess-logged {\n    display: none !important;\n  }\n  .container-quick-access-detail {\n    display: none !important;\n  }\n  .wellness-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 64px !important;\n    width: calc(100vw - 65px) !important;\n  }\n  .wellness-page .wellness-page .footer-container {\n    margin: 15px 0px 0px 0px !important;\n  }\n  .quickAccess-results {\n    display: none;\n  }\n  .detail-container {\n    margin-top: 3rem !important;\n  }\n  .column-footer {\n    margin: 30px 0px 0px 0px !important;\n  }\n}\n@media screen and (max-width: 768px) {\n  .container-data-wellness {\n    justify-content: center !important;\n    align-self: center !important;\n    align-items: center !important;\n    align-content: center !important;\n    height: 100%;\n    width: 100% !important;\n  }\n}\n@media (max-width: 576px) {\n  .wellness-page {\n    background-color: #f7f8f9;\n    padding: 0 !important;\n    margin: 0px 0px !important;\n    width: 100% !important;\n  }\n  .detail-container {\n    margin: 43px 0rem 3rem 0.5rem !important;\n  }\n}\n.title-event {\n  font-weight: 700;\n  margin-bottom: 0.5em;\n}\n\n.detail-class-title {\n  display: flex;\n  gap: 1em;\n  align-items: center;\n}\n\n.detail-title {\n  font-size: 1.5em;\n  font-weight: 700;\n  margin-bottom: 0.5em;\n}/*# sourceMappingURL=wellnesseventscontainer.css.map */","@import \"./variables\";\n\n@mixin flexCenter($justify-content, $align-items) {\n  display: flex;\n  justify-content: $justify-content;\n  align-items: $align-items;\n}\n\n@mixin settingsPage() {\n  background-color: $MainBackgroundColor !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
